import React from 'react';
import { Card, CardHeader, CardContent, Divider, Typography, Grid, Box } from '@mui/material';

export default function SourdoughRecipeCard({ doughData, recipe, loadingRecipe }) {
  return (
        <Card
        elevation={0} // ✅ Removes MUI's default shadow
        sx={{
        mt: 2,
        borderRadius: '12px',
        backgroundColor: '#f7f0e7',
        border: 'none', // ✅ Ensures no border
        boxShadow: 'none' // ✅ Removes all shadow effects
        }}
    >
  

      <CardHeader
        title="Your Sourdough Plan"
        titleTypographyProps={{ 
          textAlign: 'center', 
          fontWeight: 'bold', 
          color: '#5c3c14',
          sx: { fontSize: { xs: '1.25rem', sm: '1.5rem' } } // Smaller title font on mobile
        }}
        sx={{ borderRadius: '12px' }}
      />
      <Divider />
      <CardContent sx={{ borderRadius: '12px' }}>
      <Grid container spacing={2}>
          <Grid item xs={4} md={4}>
            <Typography variant="h6" sx={{ mb: 1, fontSize: { xs: '.9rem', sm: '1.25rem' } }}>
              Ingredients
            </Typography>
            <Typography sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}>Flour: {doughData.totalFlourOutput || 0} g</Typography>
            <Typography sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}>Water: {doughData.waterOutput || 0} g</Typography>
            <Typography sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}>Starter: {doughData.starterOutput || 0} g</Typography>
            <Typography sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}>Salt: {doughData.saltOutput || 0} g</Typography>
          </Grid>
          <Grid item xs={8} md={8}>
            <Typography variant="h6" sx={{ mb: 1, fontSize: { xs: '.9rem', sm: '1.25rem' } }}>
              Instructions
            </Typography>
            {loadingRecipe ? (
              <Box sx={{ position: 'relative', width: 70, height: 71, margin: '0 auto' }}>
                <Box
                  component="img"
                  src="/smallicon.png"
                  alt="Loading..."
                  sx={{ width: '100%', height: '100%' }}
                />
                <Box
                  component="img"
                  src="/smallicon2.png"
                  alt="Loading overlay"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    opacity: 0,
                    animation: 'fadeIn 5s ease-in-out forwards',
                    '@keyframes fadeIn': {
                      '0%': { opacity: 0 },
                      '100%': { opacity: 1 }
                    }
                  }}
                />
              </Box>
            ) : recipe ? (
              typeof recipe === 'object' ? (
                <>
                  {Object.entries(recipe).map(([title, description], index) => (
                    <Box key={index} sx={{ mb: 1 }}>
                      <Typography sx={{ fontWeight: 'bold', fontSize: { xs: '.75rem', sm: '.97rem' } }}>{title}</Typography>
                      <Typography sx={{ fontSize: { xs: '0.7rem', sm: '.9rem' } }}>{description}</Typography>
                    </Box>
                  ))}
                </>
              ) : (
                // Fallback if GPT didn't return valid JSON
                <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>{recipe}</Typography>
              )
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                No recipe yet. Hit BAKE to generate. Sorry, but if this message reappears after hitting BAKE, the app got too popular and I had to slow it down. Please do try again later though! (Leaving the Notes empty can help)
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
